import React from "react";
import { formatAmount } from "../utils/format";
import { useTranslation } from "react-i18next";
import noImage from "../icons/noImageIcon.svg";

const Rows = ({ columns = [], data = [], onRowClick, wrapLayout = false }) => {
  const { t } = useTranslation();

  const handleImageError = (e) => {
    e.target.src = noImage;
    e.target.style.width = "25px";
    e.target.style.height = "25px";
  };

  const minTableWidth = columns.reduce((total, column) => {
    const width = column.width || 150;
    // If width is a percentage, use 150px as fallback for minTableWidth calculation
    return total + (typeof width === 'string' && width.includes('%') ? 150 : width);
  }, 0);

  return (
    <div
      className={`w-full ${wrapLayout ? "overflow-y-auto overflow-x-hidden" : "overflow-x-auto"}`}
    >
      {/* Header */}
      <div
        className={`w-full flex items-center pt-4 pb-2 px-[16px] text-[#919191] text-[12px] font-semibold 
    ${wrapLayout ? "flex-wrap" : ""}`}
        style={!wrapLayout ? { minWidth: `${minTableWidth}px` } : {}}
      >
        {columns.map((column, index) => (
          <div
            key={index}
            className={`px-6 text-left 
        ${wrapLayout ? "break-words flex-1" : ""} 
        ${column.key === "actionss" ? "text-[#043F88] w-10 font-bold text-[16px] whitespace-nowrap" : ""}`}
            style={!wrapLayout ? { 
              width: column.width || '150px', 
              minWidth: typeof column.width === 'number' ? `${column.width}px` : (column.width || '150px')
            } : {}}
          >
            {column.label}
          </div>
        ))}
      </div>

      {/* Data Rows */}
      <div className="pb-4">
        {data.map((row, rowIndex) => (
          <div key={rowIndex} className="mb-2">
            {/* Main Row */}
            <div
              className={`flex items-center bg-white py-4 px-4 rounded-[12px] shadow-[0px_6px_26px_#626B7D12] cursor-pointer min-h-[72px] hover:bg-blue-50 transition-colors duration-200 
                ${wrapLayout ? "flex-wrap" : ""}`}
              style={!wrapLayout ? { minWidth: `${minTableWidth}px` } : {}}
              onClick={() => onRowClick && onRowClick(row)}
            >
              {columns.map((col, colIndex) => (
                <div
                  key={colIndex}
                  className={`px-6 text-left text-[#38485C] text-[16px] font-semibold 
    ${wrapLayout ? "break-words flex-1" : ""}`}
                  style={!wrapLayout ? { 
                    width: col.width || '150px', 
                    minWidth: typeof col.width === 'number' ? `${col.width}px` : (col.width || '150px')
                  } : {}}
                >
                  {col.render
                    ? col.render(row[col.key], row)
                    : col.key === "amount" || col.key === "attachedAmount"
                      ? formatAmount(row[col.key])
                      : col.value ? col.value(row) : row[col.key] || ""}
                </div>
              ))}
            </div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default Rows;